export default __webpack_public_path__ + "static/media/direction-wind.16810b93.png";